export const downloadBackupFile = (data, filename) => {
  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  
  // Limpeza
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 100);
};

export const parseBackupFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (event) => {
      try {
        const data = JSON.parse(event.target.result);
        
        // Validação básica da assinatura do arquivo
        if (!data.metadata || data.metadata.type !== 'conciliador_backup') {
          throw new Error('Arquivo de backup inválido ou incompatível.');
        }
        
        resolve(data);
      } catch (error) {
        reject(new Error('Erro ao ler o arquivo de backup. Certifique-se de que é um arquivo válido gerado pelo sistema.'));
      }
    };
    
    reader.onerror = () => reject(new Error('Erro de leitura do arquivo.'));
    reader.readAsText(file);
  });
};
